import React from "react";
import {
  ADD_REASON,
  DEPARTMENTAL_CODE,STATUS,
} from "../../../../enums/SuperadminWalletEnum";
import { Row } from "react-bootstrap";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";

export const SuperAdminDepartmentalWalletFilter = (props, state) => {
  return (
    <React.Fragment>
      <div className="col-12">
        {props.filter && (
          <div className="mt-3 mb-3">
            <Row>
              <div className="col-3">
                <div className="mr-3">
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="demo-simple-select-outlined-label">
                      Departmental Code
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      name="addDepartmentalCode"
                      value={props.addDepartmentalCode}
                      onChange={(e) => props.onChangeDepartmentType(e)}
                      label="date_range"
                    >
                      {DEPARTMENTAL_CODE.map((item, index) => (
                        <MenuItem key={index} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="col-3">
                <div className="mr-3">
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="demo-simple-select-outlined-label">
                      status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      name="addReason"
                      value={props.addReason}
                      onChange={(e) => props.onChangeAddReason(e)}
                      label="date_range"
                    >
                      {STATUS.map((item, index) => (
                        <MenuItem key={index} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              {/* <div className="col-3">
                          <div className="mr-3">
                            <FormControl variant="outlined" fullWidth>
                              <TextField
                                type="date"
                                lable="Select Date"
                                variant="outlined"
                                onChange={(e) => onChangeSelectDate(e)}
                                value={state.selectDate}
                              />
                            </FormControl>
                          </div>
                        </div> */}
            </Row>
            <div class="d-flex align-items-center mt-4">
              <button
                type="button"
                className="btn-md mr-4 px-5 btn btn-outline-secondary"
                onClick={props.showFilter}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn-md px-5 btn btn-danger"
                onClick={props.onFilterSave}
              >
                Save
              </button>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
